import { render, staticRenderFns } from "./NmtSettings.vue?vue&type=template&id=97821702&scoped=true&"
import script from "./NmtSettings.vue?vue&type=script&lang=js&"
export * from "./NmtSettings.vue?vue&type=script&lang=js&"
import style0 from "./NmtSettings.vue?vue&type=style&index=0&id=97821702&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97821702",
  null
  
)

export default component.exports